import {
    Text,
    Flex,
    TooltipText,
    useTooltip,
    Skeleton,
    Heading,
    Box,
    Button,
    IconButton,
    useModal,
} from "@pancakeswap/uikit";
import * as React from 'react';
import RemoveRoundedIcon from '@mui/icons-material/RemoveRounded';
import AddRoundedIcon from '@mui/icons-material/AddRounded';
import { UnsupportedChainIdError, useWeb3React } from "@web3-react/core";
import { NoEthereumProviderError } from "@web3-react/injected-connector";
import Balance from "components/Balance";
import { activeNetwork, networks } from "config/networkConfig";
import { ethers, Signer, BigNumber } from "ethers";
import { injected } from "helper/connectors";
import { useEffect, useState } from "react";
import styled, { keyframes, css } from "styled-components";
import TokenABI from "ABI/TokenABI.json";
import LpTokenABI from "ABI/LpTokenABI.json";
import addresses from "constants/contract";
import { getDrivenFarmAddress, getLockUpAddress, getTokenAddress } from "utils/addressHelpers";
import { getContract, getDrivenContract } from "utils/contractHelpers";
import Pools from "views/Pools";
// import VaultStakeModal from "../../CakeVaultCard/VaultStakeModal";
// import StakeModal from "../../Modal/StakeModal";
import { Button as Mbutton } from '@mui/material'
// import StakeFarmModal from "../../Modal/StakeFarmModal";
import { useLocation } from 'react-router-dom'
import StakeModal from "views/Pools/components/Modal/StakeModal";
import StakeFarmModal from "views/Pools/components/Modal/StakeFarmModal";
import VaultStakeModal from "views/Pools/components/CakeVaultCard/VaultStakeModal";
import { useDispatch } from "react-redux";
import { setWidx } from "store/IndexSlice";
import LoopIcon from '@mui/icons-material/Loop';



interface FarmStakeProps {
    pool: any
}

const Minplsbtn = styled(Mbutton)`
  border:2px solid #00FED9  !important;
  color: #00FED9 !important;
  height:48px;
  line-height:1;
  opacity:1;
  font-weight: 600;
  font-size: 16px !important;
  min-width:48px !important;
  width:100%;
  padding:0px !important;
`
export const ActionContainer = styled.div<{ isAutoVault?: boolean }>`
  padding: 16px;
  border: 2px solid ${({ theme }) => theme.colors.input};
  border-radius: 16px;
  flex-grow: 1;
  flex-basis: 0;
  margin-bottom: 16px;

  ${({ theme }) => theme.mediaQueries.sm} {
    margin-left: 12px;
    margin-right: 12px;
    margin-bottom: 0;
    height: auto;
  }
`;

export const ActionTitles = styled.div`
  font-weight: 600;
  font-size: 12px;
  margin-bottom: 10px;
`;

export const ActionContent = styled.div`
  /* padding: 16px; */
  -webkit-box-flex: 1;
  flex-grow: 1;
  flex-basis: 0px;
  margin-bottom: 16px;
`;
export const Fees = styled.div`
  /* padding: 16px; */
  display: flex;
  -webkit-box-pack: justify;
  justify-content: space-between;
`;
export const Staking = styled.div`
  /* padding: 16px; */
  font-weight: 600;
  font-size: 12px;
  padding-top: 10px;
`;
const ConnectButton = styled(Button)`
  -webkit-box-align: center;
  align-items: center;
  border: 0px;
  border-radius: 16px;
  box-shadow: rgb(14 14 44 / 40%) 0px -1px 0px 0px inset;
  cursor: pointer;
  display: inline-flex;
  font-family: inherit;
  font-size: 16px;
  font-weight: 600;
  -webkit-box-pack: center;
  justify-content: center;
  letter-spacing: 0.03em;
  line-height: 1;
  opacity: 1;
  outline: 0px;
  transition: background-color 0.2s ease 0s, opacity 0.2s ease 0s;
  height: 48px;
  padding: 0px 24px;
  background-color: #00FED9;
  color: black;
  /* width: 100%; */
  width: 200px;
`;

const StakeEnable = styled(Button)`
    -webkit-box-align: center;
    align-items: center;
    border-radius: 16px;
    cursor: pointer;
    display: inline-flex;
    font-family: inherit;
    font-size: 16px;
    font-weight: 600;
    -moz-box-pack: center;
    justify-content: center;
    letter-spacing: 0.03em;
    line-height: 1;
    opacity: 1;
    outline: currentcolor none 0px;
    transition: background-color 0.2s ease 0s, opacity 0.2s ease 0s;
    height: 48px;
    padding: 0px 24px;
    background-color: transparent;
    border: 2px solid #00FED9;
    box-shadow: none;
    color: white;
    width: 200px;
    /* max-width:250px; */

`

const IconButtonWrapper = styled.div`
    display: flex;
`

const StakedBalanace = styled(Box)`
    display: flex;
    justify-content: space-between;
`


const FarmStake: React.FunctionComponent<FarmStakeProps> = ({ pool }) => {
    const { error, connector, activate, deactivate, library, active, account } = useWeb3React();
    const [stakeEnable, setstackeEnable] = useState("Enable");
    const [loading, setLoading] = useState(false);
    // const [stackbutton, setStackButton] = useState(false);
    const MAX_INT = "115792089237316195423570985008687907853269984665640564039457584007913129639935";
    const allowance = async () => {
        setLoading(true);
        try {
            const signer = library.getSigner();
            const contract = getContract(LpTokenABI, pool.lpToken, signer);
            const allowance1 = await contract.allowance(account, getDrivenFarmAddress());
            // const flag = allowance1.toString() === MAX_INT;
            const flag = allowance1.toString() !== "0";
            console.log(allowance1.toString());
            // debugger;
            setstackeEnable(flag ? "Stake" : "Enable");
            setLoading(false);
            return flag;
        } catch (error) {
            console.log(error);
            setLoading(false);
        }
        return false;
    }

    const enable = async () => {
        if (stakeEnable === "Enable") {
            if (await allowance()) {
                return;
            };
        }
        setLoading(true);
        try {
            const signer = library.getSigner();
            const contract = getContract(LpTokenABI, pool.lpToken, signer);
            const tx = await contract.approve(getDrivenFarmAddress(), MAX_INT);
            // debugger;
            await tx.wait();
            setstackeEnable("Stake");
        }
        catch (err) {
            console.log(err);
        }
        setLoading(false);

    };

    const dispatch = useDispatch()
    const connectModal = () => {
        dispatch(setWidx(true))
    }
    useEffect(() => {
        if (account) {
            allowance();
        }
    }, [pool, account]);

    useEffect(() => {
        if (error) {
            // networks[activeNetwork]['chainID']
            console.log(error);
            if (error instanceof UnsupportedChainIdError) {
                // changeNetwork();
            } else if (error instanceof NoEthereumProviderError) {
                console.log("No Metamask");
            }
        }
    }, [error]);

    // const [stake, setStake] = React.useState(false);

    const [open, setOpen] = React.useState(false);

    const stake = () => setOpen(true);
    const handleClose = () => setOpen(false);

    const [unstakeopen, setUnstakeOpen] = React.useState(false);

    const unstake = () => setUnstakeOpen(true);
    const handleClose1 = () => setUnstakeOpen(false);




    const [openfarmmodal, setOpenfarmmodal] = React.useState(false);
    // const [open, setOpenfarmmodal] = React.useState(false);

    const stakefarm = () => setOpenfarmmodal(true);
    const handleClosefarm = () => setOpenfarmmodal(false);

    const [unstakeopenfarmmodal, setUnstakeOpenfarmmodal] = React.useState(false);

    const unstakefarm = () => setUnstakeOpenfarmmodal(true);
    const handleClosefarm1 = () => setUnstakeOpenfarmmodal(false);

    // async function connect(walletType) {
    //     setLoading(true);
    //     try {
    //         await deactivate();
    //         if (walletType === "metamask") {
    //             console.log("Connecting Metamsk");
    //             await activate(injected);
    //         }
    //     } catch (ex) {
    //         console.log(ex);
    //     }
    //     setLoading(false);
    // }

    // const changeNetwork = async () => {
    //     const provider = await connector.getProvider();
    //     const hexString = networks[activeNetwork]["chainId"].toString(16);
    //     await provider.request({
    //         method: "wallet_switchEthereumChain",
    //         params: [{ chainId: "0x" + hexString }],
    //     });
    // };

    const { targetRef, tooltip, tooltipVisible } = useTooltip(
        "Subtracted automatically from each yield harvest and burned.",
        { placement: "bottom-start" }
    );


    //Unstake

    const onUnstake = () => {
        onPresentVaultUnstake()
    }

    const [onPresentVaultUnstake] = useModal(<VaultStakeModal stakingMax={pool} pool={pool} isRemovingStake />)
    const actionTitle = (
        <Text
            fontSize="12px"
            bold
            color="secondary"
            as="span"
            textTransform="uppercase"
        >
            {"Recent CAKE profit"}
        </Text>
    );

    const location = useLocation();


    return (

        <>

            <>
                <Box>
                    <ActionContent>
                        <Fees>
                            <Text
                                fontSize="13px"
                                lineHeight={1.5}
                                fontWeight={600}
                                bold
                                color="#B1B3CB"
                                as="span"
                                textTransform="uppercase"
                            >
                                Deposit Fee
                            </Text>
                            <Flex>
                                <Balance
                                    lineHeight="1"
                                    bold
                                    display="inline"
                                    fontSize="13px"
                                    color="white"
                                    decimals={2}
                                    prefix=""
                                    value={pool.depositFee}
                                    unit="%"
                                />
                            </Flex>
                        </Fees>
                        <Fees>
                            <Text
                                fontSize="13px"
                                lineHeight={1.5}
                                fontWeight={600}
                                bold
                                color="#B1B3CB"
                                as="span"
                                textTransform="uppercase"
                            >
                                WITHDRAW FEE
                            </Text>
                            <Flex>
                                <Balance
                                    lineHeight="1"
                                    bold
                                    display="inline"
                                    fontSize="13px"
                                    color="white"
                                    decimals={2}
                                    prefix=""
                                    value={pool.withdrawFee}
                                    unit="%"
                                />
                            </Flex>
                        </Fees>
                        <Staking>
                            {!active ? (
                                <Text
                                    fontSize="13px"
                                    lineHeight={1.5}
                                    fontWeight={600}
                                    bold
                                    color="white"
                                    as="span"
                                    textTransform="uppercase"
                                >
                                    Start Farming
                                </Text>
                            ) : (
                                (pool.user && pool?.lpTokenDecimal ? parseFloat(ethers.utils.formatEther(pool.user?.stakeamount).toString()) === 0 : '') && <Text
                                    fontSize="13px"
                                    lineHeight={1.5}
                                    fontWeight={600}
                                    bold
                                    color="white"
                                    as="span"
                                    textTransform="uppercase"
                                >
                                    {/* {stakeEnable} Farming */}
                                    Stake DVX-BNB
                                </Text>
                            )}

                        </Staking>
                        <Flex>
                            {!active ?
                                <>
                                    <ConnectButton onClick={connectModal} disabled={loading}>
                                        Connect Wallet
                                    </ConnectButton>{" "}
                                </>
                                :

                                (pool.user && pool?.lpTokenDecimal ? parseFloat(ethers.utils.formatUnits(pool.user?.stakeamount).toString()) == 0 : '') && (<StakeEnable onClick={() => stakeEnable === "Enable" ? enable() : stakefarm()} disabled={loading}>{stakeEnable} {loading && <Box><LoopIcon className="animation-spin" sx={{ width: '18px', height: '18px' }} /></Box>}</StakeEnable>)
                                // < StakeEnable onClick={() => stakeEnable === "Enable" ? enable() : stakefarm()} disabled={loading}>{stakeEnable}</>
                            }

                        </Flex>
                        {( active && pool.user && pool?.lpTokenDecimal ? parseFloat(ethers.utils.formatEther(pool.user?.stakeamount)) > 0 : '') &&
                            <>
                                <Flex flex="1" flexDirection="column" alignSelf="flex-start">
                                    <ActionTitles>
                                        <Text fontSize="12px" bold color="#00FED9" as="span" textTransform="uppercase">
                                            {pool.token0Symbol}-{pool.token1Symbol}{' '}
                                        </Text>
                                        <Text fontSize="12px" bold color="#00FED9" as="span" textTransform="uppercase">
                                            Staked
                                        </Text>
                                    </ActionTitles>
                                    {/* <br /> */}
                                    <StakedBalanace>
                                        <Box>
                                            <Balance
                                                lineHeight="1"
                                                bold
                                                fontSize="20px"
                                                decimals={2}
                                                // value={(parseFloat(ethers.utils.formatEther(pool.user.userstack)))}

                                                value={pool.user && pool?.lpTokenDecimal ? parseFloat(ethers.utils.formatUnits(pool.user?.stakeamount, pool?.lpTokenDecimal).toString()) : 0}
                                                color="white"
                                                unit=""
                                                prefix=""
                                            />

                                            <Balance
                                                fontSize="12px"
                                                display="inline"
                                                color="#B1B3CB"
                                                decimals={2}
                                                value={(pool.RSV) * (pool.token0Price) * (parseFloat(ethers.utils.formatUnits(pool.user?.stakeamount, pool.lpTokenDecimal)))}
                                                // value={0}
                                                unit=" USD"
                                                prefix="~"
                                            />

                                        </Box>
                                        <IconButtonWrapper>

                                            <Minplsbtn variant="outlined" sx={{ borderRadius: "16px", mr: 1 }} onClick={() => unstakefarm()}>
                                                <RemoveRoundedIcon width="24px" />
                                            </Minplsbtn>

                                            <Minplsbtn variant="outlined" sx={{ borderRadius: "16px", }} onClick={() => stakefarm()}>
                                                <AddRoundedIcon width="24px" height="24px" />
                                            </Minplsbtn>
                                        </IconButtonWrapper>
                                        {tooltipVisible && tooltip}
                                    </StakedBalanace>
                                </Flex>
                            </>
                        }

                    </ActionContent>
                </Box>
            </>
            <StakeFarmModal openfarmmodal={openfarmmodal} onClose={handleClosefarm} pool={pool} stack={pool}></StakeFarmModal>
            <StakeFarmModal openfarmmodal={unstakeopenfarmmodal} onClose={handleClosefarm1} isRemovingStake pool={pool} stack={pool}></StakeFarmModal>


        </>


    );
};

export default FarmStake;
